/**
 * External dependencies.
 */
import VueScrollTo from 'vue-scrollto'

export const scrollTo = (element: string | Element, duration: number = 900, options: object = {}) => {
  let defaultScrollDuration = 900

  const scrollOptions = {
    easing: 'ease-in',
    force: true,
    cancelable: true,
    ...options
  }

  if (duration) {
    defaultScrollDuration = duration
  }

  VueScrollTo.scrollTo(element, defaultScrollDuration, scrollOptions)
}

export const asyncTimer = (timeToWait: number): Promise<void> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, timeToWait)
  })
}

export const searchForSelector = async (selector: string, tries: number = 5): Promise<Element | null> => {
  const element = document.querySelector(selector)

  if (tries <= 0) {
    return element
  }

  if (!element) {
    await asyncTimer(200)
    return searchForSelector(selector, tries - 1)
  }

  return element
}

export const isSafariBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  return userAgent.indexOf('safari') !== -1 && userAgent.indexOf('chrome') === -1
}
